import { useState } from 'react';
import { motion } from 'framer-motion';
import SubscriptionModal from './SubscriptionModal';

const SITE_LOGO = "https://customer-assets.emergentagent.com/job_9dd50a71-7bb8-45b9-bdec-566056107363/artifacts/kgdjrixe_Untitled%20design.png";
const BG_IMAGE = "https://images.unsplash.com/photo-1429962714451-bb934ecdc4ec?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwxfHxjb25jZXJ0JTIwY3Jvd2QlMjBzaWxob3VldHRlfGVufDB8fHx8MTc0MzAxMjAwMHww&ixlib=rb-4.1.0&q=85";

const SubscriptionSection = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <section 
        data-testid="subscription-section" 
        className="relative py-24 md:py-32 overflow-hidden"
      >
        {/* Background Image */}
        <div className="absolute inset-0">
          <img 
            src={BG_IMAGE}
            alt="Concert crowd"
            className="w-full h-full object-cover"
          />
          {/* Dark overlay */}
          <div className="absolute inset-0 bg-black/50" />
        </div>

        {/* Content */}
        <div className="relative z-10 max-w-7xl mx-auto px-6 sm:px-12">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-center">
            {/* Logo - Left justified */}
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="md:col-span-3 flex justify-start"
            >
              <img 
                src={SITE_LOGO}
                alt="What's Happening Baltimore"
                className="h-32 md:h-44 w-auto"
              />
            </motion.div>

            {/* Text Content - More space */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.1 }}
              className="md:col-span-9"
            >
              <p className="text-purple-400 font-semibold text-lg mb-3">
                Be A Patron of The Arts
              </p>
              <h2 className="font-outfit text-3xl sm:text-4xl lg:text-5xl font-bold text-white tracking-tight leading-tight mb-8">
                Your participation supports our efforts to promote Baltimore Arts & Culture
              </h2>

              {/* Subscribe Button */}
              <motion.button
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.2 }}
                onClick={() => setIsModalOpen(true)}
                data-testid="subscribe-modal-btn"
                className="bg-purple-600 hover:bg-purple-700 text-white px-8 py-4 rounded-2xl font-semibold text-lg transition-all duration-300 shadow-lg hover:shadow-purple-500/25"
              >
                SUBSCRIBE FOR UPDATES
              </motion.button>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Subscription Modal */}
      <SubscriptionModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
      />
    </>
  );
};

export default SubscriptionSection;
